/* eslint-disable import/no-anonymous-default-export */
export default {
    media: {
        mobile: 'screen and (max-width: 599px)',
        tablet: 'screen and (min-width: 600px) and (max-width: 1199px)',
        desktop: 'screen and (min-width: 1200px)',
    }
}

